import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-settlement',
    templateUrl: './settlement.component.html',
    styleUrls: ['./settlement.component.scss']
})
export class SettlementComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
